<h3>Crew type administration</h3>
               <hr />
               <button class="btn btn-primary pull-right" (click)="new()">Add new&nbsp;<span class="glyphicon glyphicon-plus"></span></button>
               <list-table [list]="crewtypes" [headers]="displayFields" [type]="type" (delete)="delete($event)"></list-table>